import React, { PropTypes } from 'react';
import classnames from 'classnames';

import Link from 'components/Link';
import 'styles/Button.scss';

const Button = (props) => {
  const {
    isDisabled,
    isXSmall,
    isSmall,
    isBlue,
    isGreen,
    isYellow,
    hasIcon,
    iconType,
    hasIconAnimated,
    to = "_",
    ...otherProps
  } = props;

  const className = classnames(
    'Button',
    {
      'is-disabled': isDisabled,
      'is-x-small': isXSmall,
      'is-small': isSmall,
      'is-blue': isBlue,
      'is-green': isGreen,
      'is-yellow': isYellow,
      'has-icon': hasIcon,
      ['is-animated']: !!hasIconAnimated
    }
  );
  let icon = null;

  if(hasIcon) {
    const iconClassName = classnames('icon', `icon-${iconType}`);
    icon = <span className={iconClassName} />;
  }

  return (
    <div className={className}>
      {icon}
      <Link {...otherProps} to={to} />
    </div>
  );
};

Button.propTypes = {
  isDisabled: PropTypes.bool,
  isXSmall: PropTypes.bool,
  isSmall: PropTypes.bool,
  isBlue: PropTypes.bool,
  isGreen: PropTypes.bool,
  isYellow: PropTypes.bool,
  hasIcon: PropTypes.bool,
  iconType: PropTypes.string,
  hasIconAnimated: PropTypes.bool,
  to: PropTypes.string
};

export default Button;



/** WEBPACK FOOTER **
 ** ./src/members/Main/__shared__/components/Button/index.js
 **/